import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom, Observable } from 'rxjs';
import {
    IDocType,
    IDocuments,
    IFilelistFromDB,
    IResponseFileAction,
} from '../interfaces/document.interfaces';
import { ConfigService } from './application/config.service.';
import { HttpNewService } from './application/http-new.service';
import { AuthService } from './auth.service';
import {
    IDocumentResult,
    TDocument,
    TDocumentList,
} from '../interfaces/files.interfaces';

@Injectable({
    providedIn: 'root',
})
export class FileUploadService {
    public constructor(
        // private http: HttpClient,
        private auth: AuthService,
        private configS: ConfigService,
        private httpNew: HttpNewService,
    ) {}

    public async uploadFile(
        file: File,
        tag: number,
        link_id: number,
    ): Promise<{ id: number; storagePath?: string }> {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('tag', `${tag}`);
        formData.append('linkId', `${link_id}`);
        return await lastValueFrom(
            this.httpNew.post<{ id: number; storagePath?: string }>(
                '/file/upload',
                formData,
                true,
            ),
        );
    }

    public async getFilelist(
        tag: number,
        linkId: number,
    ): Promise<Array<IFilelistFromDB>> {
        const params = {
            tag,
            linkId,
        };
        return await lastValueFrom(
            this.httpNew.get<Array<IFilelistFromDB>>('/file/list', params),
        );
    }

    public async deleteFileFromDB(
        path: string | undefined,
        id: string,
    ): Promise<IResponseFileAction> {
        return await lastValueFrom(
            this.httpNew.delete<IResponseFileAction>('/file/delete', {
                id,
                path,
            }),
        );
    }

    public uploadTmp(file: File): Promise<Array<string>> {
        return new Promise((ress, rej) => {
            // const token = null;
            let headerss = new HttpHeaders();
            // if (token && token.length > 10) {
            //     headerss = headerss.set('Authorization', 'TOKEN ' + token);
            // }
            //
            const formData: FormData = new FormData();
            formData.append('file', file);
            //
            //
            const upload$ = this.httpNew.post<Array<string>>(
                '/file/temp',
                formData,
                true,
            );

            upload$.subscribe({
                next: (result) => {
                    //
                    ress(result);
                },
                error: (err) => {
                    rej(err);
                },
            });
        });
    }

    public getDocTypeList(): Observable<Array<IDocType>> {
        const url = '/file/list_type';
        return this.httpNew.get<Array<IDocType>>(url);
    }

    public getDocList(): Observable<Array<IDocuments>> {
        const url = '/file/list_doc';
        return this.httpNew.get<Array<IDocuments>>(url);
    }

    public getDocumentsList() {
        return this.httpNew.get<TDocumentList>('/file/documents');
    }

    public getDocument(id: number, fileName: string, signal?: AbortSignal) {
        return this.httpNew.get<IDocumentResult>(
            '/file/documents', //  URL
            {
                fileId: id,
                fileName: fileName,
            },
            undefined, //  isArrayBuffer
            null, // authToken
            signal, // signal
        );
    }
}
